export default "__VITE_ASSET__DaNT3_Vg__"